import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import appUrls from '../config/urls';
import { SearchDto } from '../data/models/search-dto';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  url = appUrls.account;
  constructor(private http: HttpClient) { }

  getAccountBilling(ucid: string) {
    let obj: SearchDto = { searchKeyword: ucid }
    return this.http.post(this.url.accountBilling, obj)
  }
}
